module.exports = __webpack_public_path__ + "img/editorder.5c64fd7d.svg";